import { isMinimumPackage } from '../../../../utils/package-validator'
import { Package } from '../../../../enums/package.enum'
import { State } from '../../../../types/state'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { TaskBoardsModal } from './TaskBoardsModal'
import React, { useCallback, useEffect, useState } from 'react'
import { useRequests } from '../../../../requests/useRequests'
import { RefreshActions } from '../../../../state/refresh'
interface LinkedTaskBoardsSectionProps {
  projectId: string
}

export const LinkedTaskBoardsSection = ({
  projectId
}: LinkedTaskBoardsSectionProps) => {
  const navigate = useNavigate()
  const { package: userPackage, packageExpiredAt } = useSelector((state: State) => state.user)
  const dispatch = useDispatch()
  const requestMaker = useRequests()

  const [showTaskBoardsModal, setShowTaskBoardsModal] = useState(false)
  const [selectedTaskBoardId, setSelectedTaskBoardId] = useState<string | null>(null)
  const [availableTaskBoards, setAvailableTaskBoards] = useState<any[]>([])
  const [linkedTaskBoards, setLinkedTaskBoards] = useState<any[]>([])
  const [isLoadingTaskBoards, setIsLoadingTaskBoards] = useState(false)

  const handleGoToTaskBoard = (taskBoardId: string) => {
    navigate(`/tasks/${taskBoardId}`)
  }

  const handleOpenTaskBoardsModal = async () => {
    await fetchAllTaskBoards()
    setShowTaskBoardsModal(true)
  }

  const fetchAllTaskBoards = useCallback(async () => {
    try {
      const response = await requestMaker.getTaskBoards()
      setAvailableTaskBoards(response.data)
    } catch (error) {
      console.error('Błąd podczas pobierania tablic zadań:', error)
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Nie udało się pobrać tablic zadań'
        })
      )
    }
  }, [requestMaker, dispatch])

  const fetchLinkedTaskBoards = useCallback(async () => {
    if (!projectId) return

    setIsLoadingTaskBoards(true)
    try {
      const response = await requestMaker.getTaskBoardsByProject(projectId)
      setLinkedTaskBoards(response.data)
    } catch (error) {
      console.error('Błąd podczas pobierania powiązanych tablic zadań:', error)
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Nie udało się pobrać powiązanych tablic zadań'
        })
      )
    } finally {
      setIsLoadingTaskBoards(false)
    }
  }, [projectId, dispatch, requestMaker])

  useEffect(() => {
    fetchLinkedTaskBoards()
  }, [fetchLinkedTaskBoards])

  const handleLinkTaskBoard = async () => {
    if (!selectedTaskBoardId) return
    const success = await requestMaker.linkTaskBoardToProject(projectId, selectedTaskBoardId)
    if (success) {
      fetchLinkedTaskBoards()
      setShowTaskBoardsModal(false)
      setSelectedTaskBoardId(null)
    }
  }

  const handleUnlinkTaskBoard = async (taskBoardId: string): Promise<void> => {
    const success = await requestMaker.unlinkTaskBoardFromProject(projectId, taskBoardId)
    if (success) {
      fetchLinkedTaskBoards()
    }
  }

  return isMinimumPackage(userPackage, Package.PREMIUM, packageExpiredAt)
    ? (
      <div className='row mb-30'>
        <div className='col-sm-12'>
          <div className='card p-30'>
            <div className='projectCard'>
              <div className='tw-flex tw-flex-col tw-gap-2 md:tw-flex-row md:tw-justify-between md:tw-items-center mb-20'>
                <h4 className='tw-font-semibold'>Powiązane tablice zadań</h4>
                <div>
                  <button
                    className={`
                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                      tw-text-teal
                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                    `}
                    onClick={handleOpenTaskBoardsModal}
                    disabled={isLoadingTaskBoards}
                  >
                    <i className='fa fa-link mr-2' />
                    Powiąż istniejącą tablicę
                  </button>
                </div>
              </div>

              {isLoadingTaskBoards
                ? (
                  <div className='text-center p-30'>
                    <div className='spinner-border' role='status'>
                  <span className='sr-only'>Ładowanie...</span>
                </div>
                  </div>
                  )
                : linkedTaskBoards.length === 0
                  ? (
                    <div className='alert alert-info'>
                      <p>Ten projekt nie ma jeszcze powiązanych tablic zadań.</p>
                      <p>Możesz utworzyć nową tablicę zadań lub powiązać istniejącą.</p>
                    </div>
                    )
                  : (
                    <div className='row'>
                      {linkedTaskBoards.map(board => (
                    <div key={board.id} className='col-md-4 mb-20'>
                          <div className='card p-20 h-100 d-flex flex-column tw-p-4'>
                            <div className='mb-auto'>
                              <h5>{board.title}</h5>
                              <p className='small text-muted mb-10'>
                                Utworzono: {new Date(board.createdAt).toLocaleDateString()}
                              </p>
                              <p>{board.description}</p>
                              <div className='mt-10'>
                                <span className='badge badge-primary mr-5'>
                                Kolumny: {board.columnsCount || 0}
                              </span>
                              </div>
                            </div>
                            <div className='tw-flex tw-flex-col tw-gap-2 mt-20'>
                              <button
                                className={`
                                  tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                  tw-text-white
                                  tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-red-500 hover:tw-bg-opacity-90 focus:tw-bg-red-500
                                `}
                                onClick={async () => await handleUnlinkTaskBoard(board.id)}
                              >
                                <i className='fa fa-unlink mr-1' />
                                Usuń powiązanie
                            </button>
                              <button
                                className={`
                                  tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                  tw-text-white
                                  tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                `}
                                onClick={() => handleGoToTaskBoard(board.id)}
                              >
                                <i className='fa fa-arrow-right mr-1' />
                                Przejdź do tablicy
                            </button>
                            </div>
                          </div>
                        </div>
                  ))}
                    </div>
                    )}
            </div>
          </div>
        </div>
        <TaskBoardsModal
          show={showTaskBoardsModal}
          onClose={() => setShowTaskBoardsModal(false)}
          availableTaskBoards={availableTaskBoards}
          linkedTaskBoards={linkedTaskBoards}
          selectedTaskBoardId={selectedTaskBoardId}
          setSelectedTaskBoardId={setSelectedTaskBoardId}
          onLinkTaskBoard={handleLinkTaskBoard}
        />
      </div>
      )
    : <></>
}
